import { render, staticRenderFns } from "./ResourceListComponent.vue?vue&type=template&id=7ce77a0e"
import script from "./ResourceListComponent.vue?vue&type=script&lang=js"
export * from "./ResourceListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports